import * as GridUtil from "../common/gridFilter";
import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import { ICustomerDocument } from "./documentLibraryData";

// from the TargetTemplateType table
export let TARGETEMPLTETYPEID_LOCATION: number = 1;
export let TARGETEMPLTETYPEID_CUSTOM: number = 2;

export interface ITargetListConfigResponse {
    /// a user friendly name for the type of target
    TargetName: string;

    /// the scheme for the columns displayed in the grid
    ResultScheme: GridUtil.IResultScheme;
}

export function GetTargetsConfig(targetName: string): JQueryDeferred<Data.IResponse<ITargetListConfigResponse>> {
    return Util.callWebService(
        "/api/Targets/Config?name=" + targetName,
        "GET");
}

export interface ITargetMasterFormItem {
    /// unique ID for this value
    ID: number;

    /// the value of this fields
    Value: string;

    /// identifies what form field is associated with this item
    TargetTemplateFormItemID: number;

    /// the type of control
    ControlTypeID: number;

    /// the label to display next to the control
    FormText: string;

    /// true if the user must enter a value in this field
    IsRequired: boolean;

    // for strings, the maximum length of the field
    MaxLength: number;

    // Used to hold key of uploaded file
    TempFileKey: string | null;

    ListValues: IListValue[];

    TemplatePhraseID: number;

    TemplatePhrases: ITemplatePhraseDetail[];

}

export interface IListValue {
    ID: number;
    Value: string;
    IsActive: boolean;
}
export interface ITemplatePhraseDetail {
    ID: number;
    Phrase: string;
    SortOrder: number;
    IsActive: boolean;
}
export interface ITargetLinkedCustomerDocument {
    TargetCustomerDocumentID: number;
    CustomerDocumentID: number;
    StorageKey: string;
    IsActive: boolean;
    Description: string;
    FileName: string;
}

export interface ITargetMaster {
    /// iD of the target
    ID: number;

    /// the URL used to represent this target
    TargetTemplateURLName: string;

    /// the name of the target template
    TargetTemplateName?: string;

    /// the ID of the target template
    TargetTemplateID?: number;

    /// indicates if this target is active or not
    IsActive: boolean;

    /// if true, then this target includes the address fields
    HasAddressFields: boolean;

    /// if true, then this target includes custom fields
    HasCustomFields: boolean;

    /// address information associated with the target.
    /// only used if HasAddressFields is true.
    AddressFormItems: ITargetMasterFormItem[];

    /// custom fields associated with the target.
    /// only used if HasCustomFields is true.
    FormItems: ITargetMasterFormItem[];

    States: Array<Data.ICodeModel<number>>;

    AllCustomerDocuments: ICustomerDocument[];

    LinkedCustomerDocuments: ITargetLinkedCustomerDocument[];

}

export interface ITargetImportRecord {
    IsValid: boolean;
    Error: string;
    Columns: ITargetMasterFormItem;
}

export interface ITargetImportVerificationResult {
    FileFormatIsValid: boolean;
    FileHasRows: boolean;
    Columns: ITargetMasterFormItem[];
    ValidRecords: ITargetImportRecord[];
    InvalidRecords: ITargetImportRecord[];
}

export function GetTargetMaster(targetName: string, targetID?: number): JQueryDeferred<Data.IResponse<ITargetMaster>> {
    let url: string = "/api/Target/Get/" + targetName;
    if (targetID != null && targetID > 0) {
        url += "/" + targetID;
    }

    return Util.callWebService(url, "GET");
}

export function Save(targetMaster: ITargetMaster): JQueryDeferred<Data.IResponse<ITargetMaster>> {
    return Util.callWebService("/api/Target/Save", "POST", targetMaster);
}

/// used to change the IsActive status of a Target object
export interface ITargetSetIsActiveRequest {
    /// the ID of the Target to change.
    TargetID: number;

    /// the new value for the IsActive status.
    IsActive: boolean;
}

export function SetIsActive(request: ITargetSetIsActiveRequest): JQueryDeferred<Data.IResponse<string>> {
    return Util.callWebService(
        "/api/Target/SetIsActive",
        "POST",
        request);
}

export function ValidateTargetImportFile(targetTemplateID: number, importFileKey: string): JQueryDeferred<Data.IResponse<ITargetImportVerificationResult>> {
    return Util.callWebService(
        `/api/Targets/VerifyImport/${targetTemplateID}`,
        "POST",
        importFileKey);
}

export function ProcessImport(targetTemplateID: number, importFileKey: string): JQueryDeferred<Data.IResponse<number>> {
    return Util.callWebService(
        `/api/Targets/ProcessImport/${targetTemplateID}`,
        "POST",
        importFileKey);
}

export interface ITargetImportConfiguration {
    TargetTemplateID: number;
    TargetTemplateName: string;
    TargetTemplateURLName: string;
    FormItems: ITargetMasterFormItem[];
}

export function GetImportConfiguration(targetName: string): JQueryDeferred<Data.IResponse<ITargetImportConfiguration>> {
    return Util.callWebService(
        `/api/Target/GetImportConfiguration/${targetName}`,
        "GET");
}
export function getTargetTemplate(templateID: number): JQuery.Deferred<any, any, any> {
    return Util.callWebService(
        "/api/TargetTemplate/GetTargetTemplate",
        "POST",
        templateID);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/targetData.ts